import 'jquery'
import 'jquery-migrate'
import 'bootstrap'
import 'jquery-ui'
import 'sparklines'
import 'bootstrap-select'
import 'moment'
require('eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker')
require('superclick/superclick')
require('progressbar/progressbar')
require('input-switch/inputswitch-alt')
require('slidebars/slidebars')
require('content-box/contentbox')
require('overlay/overlay')
require('datatable/datatable')
require('datatable/datatable-bootstrap')
require('js-init/layout.js')
require('js-init/widgets-init.js')


// WEBPACK FOOTER //
// ./resources/assets/js/app.js